import { render, staticRenderFns } from "./OidcCallback.vue?vue&type=template&id=1e7f042f&"
import script from "./OidcCallback.vue?vue&type=script&lang=js&"
export * from "./OidcCallback.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports